/**
 * This error occurs when calling a supplemental function, but it isn't implemented. This only happens from iframes
 */
export class PlatformLayerSupplementalFunctionNotImplementedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PlatformLayerSupplementalFunctionNotImplementedError';
  }
}
